<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Master</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
      </div>
    </div>
    <div class="pos intro-y grid gap-5 my-8">
      <!-- BEGIN: Item List -->
      <div class="intro-y col-span-12 lg:col-span-8">
        <div class="grid grid-cols-12 gap-5 mt-5" v-if="masters_rights['properties'].includes(userDetails.user_role)">
          <template v-for="(master,index) in masters" :key="index">
            <div class="col-span-12 sm:col-span-4 2xl:col-span-3 box cursor-pointer zoom-in" v-if="master.user_roles.includes(userDetails.user_role)">

              <router-link class="col-span-12 sm:col-span-4 2xl:col-span-3 box cursor-pointer zoom-in px-6" :to="master.to"
              >
                  <div class="font-medium text-base text-center">{{ master.name }}</div>
              </router-link>
            </div>
        </template>
        </div>
         <h2 class="text-lg font-medium mr-auto  border-t mt-5 pt-5 border-theme-5" v-if="masters_rights['departments'].includes(userDetails.user_role)">Process & Department</h2>
        <div class="grid grid-cols-12 gap-5 mt-5" v-if="masters_rights['departments'].includes(userDetails.user_role)">
          <template v-for="(master,index) in departments" :key="index">
            <div class="col-span-12 sm:col-span-4 2xl:col-span-3 box cursor-pointer zoom-in" v-if="master.user_roles.includes(userDetails.user_role)">

              <router-link class="col-span-12 sm:col-span-4 2xl:col-span-3 box cursor-pointer zoom-in px-6" :to="master.to"
              >
                  <div class="font-medium text-base text-center">{{ master.name }}</div>
              </router-link>
            </div>
        </template>
        </div>
         <h2 class="text-lg font-medium mr-auto  border-t mt-5 pt-5 border-theme-5" v-if="masters_rights['users'].includes(userDetails.user_role)">Users</h2>
        <div class="grid grid-cols-12 gap-5 mt-5" v-if="masters_rights['users'].includes(userDetails.user_role)">
          <template v-for="(master,index) in users" :key="index">
            <div class="col-span-12 sm:col-span-4 2xl:col-span-3 box cursor-pointer zoom-in" v-if="master.user_roles.includes(userDetails.user_role)">

              <router-link class="col-span-12 sm:col-span-4 2xl:col-span-3 box cursor-pointer zoom-in px-6" :to="master.to"
              >
                  <div class="font-medium text-base text-center">{{ master.name }}</div>
              </router-link>
            </div>
          </template>
        </div>
        <h2 class="text-lg font-medium mr-auto  border-t mt-5 pt-5 border-theme-5" v-if="masters_rights['rates'].includes(userDetails.user_role)">Rates</h2>
        <div class="grid grid-cols-12 gap-5 mt-5" v-if="masters_rights['rates'].includes(userDetails.user_role)">
          <template v-for="(master,index) in Rates" :key="index">
            <div class="col-span-12 sm:col-span-4 2xl:col-span-3 box cursor-pointer zoom-in" v-if="master.user_roles.includes(userDetails.user_role)">

              <router-link class="col-span-12 sm:col-span-4 2xl:col-span-3 box cursor-pointer zoom-in px-6" :to="master.to"
              >
                  <div class="font-medium text-base text-center">{{ master.name }}</div>
              </router-link>
            </div>
          </template>
        </div>
      </div>
      <!-- END: Item List -->
    </div>
  </div>
</template>
<script>
import {
    useStore
} from '@/store'
import store from '@/store'
import { computed, defineComponent, onMounted } from 'vue'

export default defineComponent({
  setup() {
     const store = useStore()
    const userDetails = computed(() => store.state.user.currentUser)
    const settings = computed(() => store.state.user.settings)
    const masters_rights = {
      'properties': [1],
      'users': [1, 8],
      'departments': [1],
      'rates': [1],
    }
    const masters = [
      {
        name: 'Color',
        to: { name: 'color' },
        access: 103,
        user_roles: [1],
      },
      {
        name: 'Cut',
        to: { name: 'cut' },
        access: 104,
        user_roles: [1],
      },
      {
        name: 'Purity',
        to: { name: 'purity' },
        access: 105,
        user_roles: [1],
      },
      {
        name: 'Polish',
        to: { name: 'polish' },
        access: 106,
        user_roles: [1],
      },
      {
        name: 'Shape',
        to: { name: 'shape' },
        access: 107,
        user_roles: [1],
      },
      {
        name: 'Stone',
        to: { name: 'stone' },
        access: 108,
        user_roles: [1],
      },
      {
        name: 'Symmetry',
        to: { name: 'symmetry' },
        access: 109,
        user_roles: [1],
      },
      {
        name: 'Fluorescence',
        to: { name: 'fluerocent' },
        access: 110,
        user_roles: [1],
      },
      {
        name: 'Tension',
        to: { name: 'tension' },
        access: 111,
        user_roles: [1],
      },
      {
        name: 'Lab. Certificate',
        to: { name: 'lab-certificate' },
        access: 113,
        user_roles: [1],
      },
      {
        name: 'Ratio',
        to: { name: 'ratio' },
        access: 114,
        user_roles: [1],
      },
      {
        name: 'Tabl',
        to: { name: 'tabl' },
        access: 114,
        user_roles: [1],
      },
      {
        name: 'Height',
        to: { name: 'height' },
        access: 114,
        user_roles: [1],
      },
      {
        name: 'Length',
        to: { name: 'length' },
        access: 114,
        user_roles: [1],
      },
      {
        name: 'Width',
        to: { name: 'width' },
        access: 114,
        user_roles: [1],
      },
      {
        name: 'Back',
        to: { name: 'back' },
        access: 114,
        user_roles: [1],
      },
      {
        name: 'Charni',
        to: { name: 'charni' },
        access: 114,
        user_roles: [1],
      },
      {
        name: 'Mix Charni',
        to: { name: 'mix-charni' },
        access: 114,
        user_roles: [1],
      },
      // {
      //   name: 'Ls Issue Types',
      //   to: { name: 'ls-issue-types' },
      //   user_roles: [1],
      //   access: 114
      // },
      ...(settings.value?.DIAMOND_TYPE_VISIBLE == 1 ? [{
        name: 'Rough Type',
        to: { name: 'diamond-type' },
        user_roles: [1],
        access: 114
      }] : []),
    ]
    const users = [
      {
        name: 'Vendor Party',
        to: { name: 'vendor-details' },
        access: 201,
        user_roles: [1, 8],
      },
      ...(settings.value?.PURCHASE_PARTY_VISIBLE == 1 ? [{
        name: 'Purchase Party',
        to: { name: 'purchase-party-details' },
        access: 201,
        user_roles: [1, 8],
      }] : []),
      {
        name: 'Manager',
        to: { name: 'manager-details' },
        access: 202,
        user_roles: [1],
      },
      {
        name: 'Employee',
        to: { name: 'employee-details' },
        access: 203,
        user_roles: [1, 8],
      },
      {
        name: 'Job Work',
        to: { name: 'jober-details' },
        access: 204,
        user_roles: [1, 8],
      },
      {
        name: 'Planner',
        to: { name: 'planner-details' },
        access: 240,
        user_roles: [1, 8],
      },
    ]
    const departments = [
      {
        name: 'Process',
        to: { name: 'process' },
        access: 205,
        user_roles: [1],
      },
      {
        name: 'Department',
        to: { name: 'department' },
        access: 206,
        user_roles: [1, 8],
      },
    ]
    const Rates = [
      {
        name: 'Manual Calculate',
        to: { name: 'manual-rate-list' },
        access: 208,
        user_roles: [1],
      },
      {
        name: 'Rapo Rates',
        to: { name: 'repo-rates' },
        access: 247,
        user_roles: [1],
      },
      {
        name: 'Company Rates',
        to: { name: 'company-rates' },
        access: 247,
        user_roles: [1],
      },
      {
        name: 'Majuri Alert',
        to: { name: 'costing-rates' },
        access: 114,
        user_roles: [1],
      },
      {
        name: 'Margin / Costing',
        to: { name: 'margin-costing-rates' },
        access: 114,
        user_roles: [1],
      },
    ]
    const accesses = computed(() => store.state.user.actions)

    onMounted(() => {

      if(settings.value && settings.value['LS_METHOD'] == "dhanush") {

        // Remove Ls Issue Types from Masters
        // find and remove
        const index = masters.findIndex((item) => item.name === "Ls Issue Types");
        if (index !== -1) {
          masters.splice(index, 1);
        }

      }
    })
    return {
      masters,
      accesses,
      users,
      Rates,
      departments,
      userDetails,
      masters_rights
    }
  }
})
</script>
